import { gsap } from "gsap";

export default class VideoFlexible {
  constructor(view) {
    this.view = view;
    this.video = this.view.querySelector("iframe");
    this.placeholder = this.view.querySelector(".section-video__placeholder");
    this.player = null;

    // Vars
    this.videoPercent = 0;
    this.videoPercent10Passed = false;
    this.videoPercent25Passed = false;
    this.videoPercent50Passed = false;
    this.videoPercent75Passed = false;
    this.videoPercent90Passed = false;

    // Bindings
    this.playVideo = this.playVideo.bind(this);
    this.cookiebotOnAccept = this.cookiebotOnAccept.bind(this);
    this.onPlayerStateChange = this.onPlayerStateChange.bind(this);

    // Listeners
    this.placeholder.addEventListener("click", this.playVideo);

    // Methods
    gsap.delayedCall(0.5, () => {
      this.video.style.pointerEvents = "none";
      if (window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing) {
        this.initYoutubeApi();
      } else {
        window.addEventListener("CookiebotOnAccept", this.cookiebotOnAccept);
      }
    });
  }

  initYoutubeApi() {
    gsap.delayedCall(0.5, () => {
      this.onYouTubeIframeAPIReady();
    });
  }

  onYouTubeIframeAPIReady() {
    if (!this.player) {
      this.player = new YT.Player(this.video, {
        events: {
          onStateChange: this.onPlayerStateChange,
        },
      });

      // Make video clickable
      this.video.style.pointerEvents = "auto";
    }
  }

  playVideo() {
    if (this.player) this.player.playVideo();
    gsap.to(this.placeholder, { autoAlpha: 0, duration: 0.6 });
  }

  cookiebotOnAccept() {
    if (window.Cookiebot.consent.marketing) {
      gsap.delayedCall(0.5, () => {
        this.onYouTubeIframeAPIReady();
      });
    }
  }

  onPlayerStateChange(event) {
    // Get video percent
    this.videoPercent = Math.round((this.player.getCurrentTime() / this.player.getDuration()) * 100);

    // Check if the player is in the PLAYING state
    if (event.data === YT.PlayerState.PLAYING) {
      this.trackingVideo("play");

      // Add an event listener for time updates
      setInterval(() => {
        this.videoPercent = Math.round((this.player.getCurrentTime() / this.player.getDuration()) * 100);
        if ((this.videoPercent == 10 && !this.videoPercent10Passed) || (this.videoPercent == 25 && !this.videoPercent25Passed) || (this.videoPercent == 50 && !this.videoPercent50Passed) || (this.videoPercent == 75 && !this.videoPercent75Passed) || (this.videoPercent == 90 && !this.videoPercent90Passed)) {
          if (this.videoPercent == 10) this.videoPercent10Passed = true;
          if (this.videoPercent == 25) this.videoPercent25Passed = true;
          if (this.videoPercent == 50) this.videoPercent50Passed = true;
          if (this.videoPercent == 75) this.videoPercent75Passed = true;
          if (this.videoPercent == 90) this.videoPercent90Passed = true;
          this.trackingVideo("progress");
        }
      }, 100); // Check for time updates every 0.1 second
    }

    if (event.data === YT.PlayerState.ENDED) {
      this.trackingVideo("complete");
    }

    if (event.data === YT.PlayerState.PAUSED) {
      this.trackingVideo("pause");
    }
  }

  trackingVideo(status) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "video",
      video_status: status,
      video_provider: "youtube",
      video_percent: status == "complete" ? 100 : this.videoPercent,
      video_title: this.player.videoTitle,
      video_url: this.video.src,
      video_duration: this.player.getDuration(),
      video_current_time: status == "complete" ? this.player.getDuration() : Math.round(this.player.getCurrentTime()),
    });
  }
}
